import React, { useState,useEffect }  from 'react';
import {Link} from 'react-router-dom'
import axios from 'axios';

import { BASE_URL } from '../Config/Base';
import { ToastContainer, toast } from 'react-toastify';
import { Oval } from  'react-loader-spinner'
import _ from 'lodash'

const pageSize =5;
const TecTechnologyMain = () => {


   
  useEffect(()=>{ 
    document.getElementById("PopAAdd").style.display="none"
    document.getElementById("PopATable").style.display="none"
    getTecTechnology()

    setpop(true);
    setTimeout(() => {
            
      getroleAction() 
      
       }, 1000);
    setTimeout(() => {
            
      setpop(false);
      getAssignedAction()
    
        
       }, 2000);

   
  }, [])
  const[pop,setpop] = useState(false);
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

  const [sectionTechnology, setSectionTechnology] = useState([])
  const [EditSectionTechnology, setEditSectionTechnology] =useState([])

  const [paginatedPosts, setpaginatedPosts] = useState();
  const [currentPage, setcurrentPage] = useState(1);

  ///getTecTechnology


  function getTecTechnology()
  {



  fetch(`${BASE_URL}/Tec/GettecTechnology`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",

      

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())

    .then(data => {
      console.log("DatasectionA", data);
      setSectionTechnology(data)
      setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        }
    );



      }
      const pageCount = sectionTechnology? Math.ceil(sectionTechnology.length/pageSize) :0;
      // if (pageCount === 1)
      // return null;
      
      const pages = _.range(1, pageCount+1)
      
      const pagination =(pageNo)=>{
      
        // if (pageCount === 1)
      // return null;
      setcurrentPage(pageNo);
      const startIndex = (pageNo - 1) * pageSize;
      const paginatedPost = _(sectionTechnology).slice(startIndex).take(pageSize).value();
      setpaginatedPosts(paginatedPost)
      }
      const onNext = () => {


        pagination(currentPage + 1);
      };
    
      const onPrevious = () => {
        pagination(currentPage - 1);
      };
      ///submitsection

   const [fileTechnology, setFileTechnology] = useState();
   const [fileTechnologyImg, setFileTechnologyImg] = useState();
   // console.log(file)
   
   const handleFileChangeTechnology = (e) => {
    
       setFileTechnology(e.target.files[0]);
       setFileTechnologyImg(URL.createObjectURL(e.target.files[0]));
   };
 
   function submitsectionTechnology(){

    var UserId= localStorage.getItem('UserId')

     var textTechnology = document.getElementById("text").value;

     
   
    
     
     if(!fileTechnology){

       document.getElementById("AddErrA").innerHTML="Logo Required"

     }
     else if(fileTechnology){

       document.getElementById("AddErrA").innerHTML=" "

     }

     if(!textTechnology){

      document.getElementById("AddErrB").innerHTML="Technology Name Required"

    }
    else if(textTechnology){

      document.getElementById("AddErrB").innerHTML=" "

    }
    

     if(textTechnology &&fileTechnology){



    const body =
     {
       
       Text:textTechnology, 
       Image:fileTechnology,
       
       ActiveStatus:0,
       DeleteStatus:0,
       CreatedBy:UserId
       

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/AddtecTechnology`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){
          
          setSuccessToast(true)
           
          
             setTimeout(() => {
             
              getTecTechnology()
              setSuccessToast(false)
              closeTechnologyAddForm()
             }, 2000);
           }

   
     })
     .catch(error => {
       console.log(error);
      alert("failed !")
    

     })
       
   }

   }


   
     ////Get Particular Data PostMethod

     function editSectionTechnology(Id){

      SelectParticular(Id)
      
      document.getElementById("TechnologyEditPop").style.display = "block";
     
    }
      function SelectParticular(Id){
    const body =
     {
       
      id:Id
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/EdittecTechnology`,
            data:body, 
            headers: {
                 "Content-type": "application/json",
                 'Authorization':bearer 
             }     
         }) 
         
    
         .then((response) =>{
           console.log(JSON.stringify(response.data));
      
       
           setEditSectionTechnology(response.data)

          
      
        })
        .catch(error => {
          console.log(error);
          
        })

     }



     function updateSectionTechnology(Id){


      var UserId= localStorage.getItem('UserId')
       var TextTechnology = document.getElementById("textA").value;
       var ImagefileTechnology = document.getElementById("tecimage").src;

      

       if(!TextTechnology){

         document.getElementById("ErrB").innerHTML="Technology Name Required"

       }
       else if(TextTechnology){

         document.getElementById("ErrB").innerHTML=" "

       }
       
       
      
      
       if(TextTechnology ){


       



    const body =
     {
       Id:Id,
       Text:TextTechnology, 
       Image:fileTechnology,
       
       OldImage:ImagefileTechnology,
       EditedBy:UserId

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/UpdatetecTechnology`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){
        
          setUpdateToast(true)
          closeTechnologyEditForm()
             setTimeout(() => {
              setcurrentPage(1)
              getTecTechnology()
              setUpdateToast(false)
              
             }, 2000);
           }
   
     })
     .catch(error => {
       console.log(error);
      alert("failed !")
   
     })
       
    
   }

     }
   

   ///DeleteSectionA

   function ConfirmDelete(Id){

    SelectParticular(Id)
    setTimeout(() => {
      document.getElementById("modaldeleteForm").style.display = "block";
    },1000);
  
  }

   function DeleteSectionTechnology(Id){

 
   

    const body =
     {
       Id:Id,
    
      

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/DeletetecTechnology`,
            data:body, 
            headers: {
               "Content-type": "application/json",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        
        closeForm()
           setDeleteErrToast(true)
           
             setTimeout(() => {
             
              getTecTechnology()
              setDeleteErrToast(false)
              setcurrentPage(1)
             }, 2000);
            
             
           
   
     })
     .catch(error => {
       console.log(error);
       alert("failed !")
      
     })
       
    

   

   }


//function closeform

function closeForm(){

  document.getElementById("modaldeleteForm").style.display ="None"

}


   //closeAddForm

   function closeTechnologyAddForm(){


    setFileTechnology();
   
    setFileTechnologyImg();
    document.getElementById("AddErrA").innerHTML=" "
    document.getElementById("AddErrB").innerHTML=" "
   
   
    document.getElementById("tecform").reset();
           
    document.getElementById("TechnologyAddPop").style.display = "none";
   
   
  }

 
  
   //closeEditForm

  function closeTechnologyEditForm(){

   setFileTechnology();
   setFileTechnologyImg();
   document.getElementById("ErrB").innerHTML=" "
  
   document.getElementById("teceditform").reset();

   
   document.getElementById("TechnologyEditPop").style.display = "none";
  }


  //OpenAddForm

  function openTechnologyForm(){

    document.getElementById("TechnologyAddPop").style.display = "block";

  }


  function getroleAction(){


    let LoginRole= localStorage.getItem("Role");
    
   
    console.log('checkrole',LoginRole);
    const body =
    {
      
     role:LoginRole
    }
    console.log('body',body);
   
   
    axios({
           method:"POST",
           url :`${BASE_URL}/Tec/GetTecRoleAction`,
           data:body, 
           headers: {
                "Content-type": "application/json",
                "Authorization": bearer,
            }     
        }) 
        
   
        .then((response) =>{
          console.log(response.data);
     
       
       
                
          localStorage.setItem("LoginAction",JSON.stringify(response.data))
          localStorage.getItem("LoginAction");
       })
       .catch(error => {
         console.log(error);
   })
   }
   
   const[editicon,setediticon] = useState(false);
   const[delicon,setdelicon] = useState(false);
   const[denied,setdenied] = useState(false);     
    function getAssignedAction(){
   
   
   
     ////Admin
       
       let LoginRoleId= localStorage.getItem("RoleId");
   
       let CheckSAdmin = LoginRoleId.includes("00")
       let CheckAdmin =LoginRoleId.includes("01")
   
   
     /////////////Teammate
       let LoginAction =  localStorage.getItem("LoginAction");
       let TecRoleAction =  JSON.parse(LoginAction);
       let roleAction = TecRoleAction.map((e)=>e.roleAction);
       console.log(roleAction);
       
       let roles = roleAction.toString();
       let roleResult = roles.includes('Add')
       console.log(roleResult)
       
       let roleResultA = roles.includes('View')
       console.log(roleResultA)
       
       let roleResultB = roles.includes('Edit')
       console.log(roleResultB)
       
       let roleResultC = roles.includes('Delete')
       console.log(roleResultC)
   
   
      
   
       if(roleResult==true && CheckSAdmin==false && CheckAdmin==false){
   
         document.getElementById('PopAAdd').style.display ="block";
       }
       else if(CheckSAdmin==true || CheckAdmin==true){
         document.getElementById('PopAAdd').style.display ="block";
       }
       else{
         document.getElementById('PopAAdd').style.display ="none";
   
       }
       if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
   
         document.getElementById('PopATable').style.display ="block";
       }
       else if(CheckSAdmin==true || CheckAdmin==true){
         document.getElementById('PopATable').style.display ="block";
       }
       else{
         document.getElementById('PopATable').style.display ="none";
   
       }
       if(roleResultB==true  && CheckSAdmin==false && CheckAdmin==false){
     
         setediticon(true)
       }
       else if(CheckSAdmin==true || CheckAdmin==true){
         setediticon(true)
       }
       else{
         setediticon(false)
   
       }
       if(roleResultC==true  && CheckSAdmin==false && CheckAdmin==false){
   
         setdelicon(true)
       }
       else if(CheckSAdmin==true || CheckAdmin==true){
         setdelicon(true)
       }
       else{
         setdelicon(false)
   
       }
   
       if(roleResultB==false  && roleResultC==false && CheckSAdmin==false && CheckAdmin==false){
   
         setdenied(true)
       }
       else{
   
         setdenied(false)
       }

       if( roleResultA==false && CheckSAdmin==false && CheckAdmin==false){
        document.getElementById("TecActionDenied").innerHTML="View Table is not Assigned"
         }

   
     }
       


     const[SuccessToast,setSuccessToast] = useState(false);  
     const[UpdateToast,setUpdateToast] = useState(false);  
     const[DeleteToast,setDeleteErrToast] = useState(false);
    
  return (
    <div className='tec-addmain'>
    
        
  {/* <div className="tec-addgrid-layout">
<div className="tec-addmain-top">
  <div className='tec-addmain-back'>
  <Link to='/Tecsection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
  </div> 
  <span>Technologies</span>
  
  </div>
  </div> */}

<div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">TECHNOLOGY</span></span>
 
 <div className='tec-addmain-back'>
  <Link to="/TecSTechnology"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
  </div></p> 

 {/* <hr></hr> */}
 </div>
    </div>   


    {/* Toast */}
    {SuccessToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Added Successfully</p></div>
   
  </div></div></div></div>:null}
   {/* Toast */}
  {DeleteToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Deleted Successfully</p></div>
   
  </div></div></div></div>:null} 


   {/* Toast */}
   {UpdateToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Updated Successfully!</p></div>
   
  </div></div></div></div>:null}

  <div className='tec-addmain-add' id="PopAAdd">
      <button className='add-user' onClick={openTechnologyForm}>  Add Technology</button>
 </div>
    
  <div>
    
    <div className='tec-sectionMain' id="PopATable">
    
    {
  sectionTechnology.length==0 ? (<div id="TecApiFail">" No Data Found "</div>):(  
<div>
<div className='tectable'>

  <div class="tec-table_responsive">


<table>
  <thead>
    <tr>
      <th>Logo</th>
      <th>Name</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {paginatedPosts.map((e)=>{
    
  
    return<tr>
   
  
    <td><img src={e.image} alt="imgA" id="sectionImage"></img></td>
    <td>{e.text}</td>
    <td style={{whiteSpace:"nowrap"}}>
    {editicon?<span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>editSectionTechnology(e.id)} id="tecEditicon"></i></span>:null} &nbsp;&nbsp;
      {delicon?<span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id)} id="tecDelicon"></i></span>:null}
      {denied?<span className='error'>Denied</span>:null}
      </td>
    </tr>
 } )}
  </tbody>
</table>

</div>
</div>

<br></br>
{pageCount==1?null:<nav  id="tecpagenav">
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            
            
            
            <p className='tecpage-link'onClick={()=>pagination(page)}>
            {page}
            </p>
            </li>
        ))
      }
        */}
    {currentPage >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="tecpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}
    </ul>
  </nav>}
</div>
)}
    </div>

    {/* EditTechnology */}
 <div className='tec-pop-fade' id="TechnologyEditPop">
{EditSectionTechnology.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"150px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT SECTION</h4>
        <button type="button" className="close" onClick={closeTechnologyEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="teceditform" onSubmit={()=>updateSectionTechnology(e.id)}>
      <div className="modal-body mx-3">
        
        <div className="text-center md-form mb-5" style={{marginTop:"-25px"}}>
        {/* <label id="sectionlable">Logo</label> */}
       
         <input type="file" onChange={handleFileChangeTechnology} style={{opacity:"0",position:"relative",top:"50px",left:"200px",zIndex:"1"}}/>
         {!fileTechnologyImg?<img id="tecimage" src={e.image}  /> :  <img id="tecimage" src={fileTechnologyImg}  />  }
         <span id="editimg-Tec"><i class="fa fa-pencil" aria-hidden="true" ></i></span>
        </div>

        <div className="md-form mb-4">
        <label id="sectionlable">Name</label> 
          <input type="text" id="textA"  defaultValue={e.text}/>
          <span id="ErrB" className='error'></span>
        </div> 
      
        
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Update</button>
      </div>
      </form>
    </div>
  </div>})}

</div>

{/* AddTechnology */}
<div className='tec-pop-fade' id="TechnologyAddPop">

  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"180px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD SECTION</h4>
        <button type="button" className="close" onClick={closeTechnologyAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="tecform" onSubmit={submitsectionTechnology} >
      <div className="modal-body mx-3">
       
        <div className="md-form mb-5">
          <label id="sectionlable">Logo</label>  
 
         <input type="file" onChange={handleFileChangeTechnology}/>
         
         <span id="AddErrA" className='error'></span>
        </div>

        <div className="md-form mb-5">
           
           <label id="sectionlable">Name</label> 
             <input type="text" id="text"/>
             <span id="AddErrB" className='error'></span>
           </div> 
         
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Add</button>
      </div>
      </form>
    </div>
  </div>

</div> 

    </div>
    {pop? <div id="Loader">
<Oval
  height={40}
  width={50}

  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}

{EditSectionTechnology.map((e)=>{ 
   return<div className="tec-pop-fade" id="modaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete <span>{e.userName}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteSectionTechnology(e.id)} type='submit'>Delete</button>
        <button className="tec-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}

<div id="TecDenied">
   <span id="TecActionDenied"></span>

   </div>
    </div>
  )
}

export default TecTechnologyMain
